import React from "react";
import { render } from "react-dom";

export default function Privacy() {
  return <div>This is Astroworker's privacy and policy page.</div>;
}
